import { QuestionAnswerMap } from '@care-portals/api-interfaces';

const questionsModel = [
  {
    field: 'zalud_throatPain_redFlagSymptoms',
    label: 'Are you experiencing any of the following?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          value: 'Drooling or inability to swallow saliva',
          key: 'drooling_inability_swallow'
        },
        {
          value: 'One-sided throat pain WITH difficulty opening your mouth',
          key: 'one_sided_throat_pain'
        },
        { value: 'None of the above', key: 'none', uncheckOthers: true }
      ]
    }
  },
  {
    field: 'zalud_throatPain_fever',
    label: 'Do you currently have a fever?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'No fever', key: 'no_fever' },
        { value: 'Mild fever (100.4–102°F)', key: 'mild_fever' },
        { value: 'High fever (≥102°F)', key: 'high_fever' },
        { value: "I don't know", key: 'unknown' }
      ]
    }
  },
  {
    field: 'zalud_throatPain_strepTest',
    label:
      'Have you had a rapid strep test or culture in the past 3 days?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes – positive', key: 'yes_positive' },
        { value: 'Yes – negative', key: 'yes_negative' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'zalud_throatPain_strepExposure',
    label:
      'Have you had known exposure to someone with a confirmed strep infection?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'zalud_throatPain_throatSymptoms',
    label: 'Which of these throat symptoms are you experiencing?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { value: 'Sudden start of intense pain', key: 'sudden_intense_pain' },
        { value: 'Pain when swallowing', key: 'pain_swallowing' },
        { value: 'Red or swollen tonsils', key: 'red_swollen_tonsils' },
        {
          value: 'White patches or spots in the back of the throat',
          key: 'white_patches_throat'
        },
        {
          value: 'Painful or swollen lymph nodes in the neck',
          key: 'swollen_lymph_nodes'
        }
      ]
    }
  },
  {
    field: 'zalud_throatPain_otherSymptoms',
    label: 'Are you experiencing any of these other symptoms?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { value: 'Cough', key: 'cough' },
        { value: 'Hoarseness or loss of voice', key: 'hoarseness' },
        { value: 'Runny or stuffy nose', key: 'runny_stuffy_nose' },
        { value: 'Pink eye (red/itchy eyes)', key: 'pink_eye' },
        { value: 'Headache', key: 'headache' },
        { value: 'Diarrhea', key: 'diarrhea' },
        { value: 'None of the above', key: 'none', uncheckOthers: true }
      ]
    }
  },
  {
    field: 'zalud_throatPain_symptomDuration',
    label: 'How long have your symptoms lasted?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: '1–2 days', key: '1_to_2_days' },
        { value: '3–5 days', key: '3_to_5_days' },
        { value: 'More than 5 days', key: 'more_than_5_days' }
      ]
    }
  },
  {
    field: 'zalud_throatPain_additionalComments',
    label:
      'Are there any additional symptoms or comments related to your current condition that were not covered in this form?',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'zalud_throatPain_additionalComments'
    }
  },
  {
    field: 'zalud_throatPain_consent',
    label: 'Consent',
    type: 'select',
    educationalSlide: `I consent that by submitting this form I acknowledge that the responses are truthful and accurate to the best of my knowledge, and understand that if I am or become pregnant, or use medications off-label, I should consult a qualified health care professional for individualized guidance.`,
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'I have read the information and I DO NOT wish to proceed',
          class: 'option-decline',
          key: 'do_not_proceed'
        },
        {
          value:
            'I have read and understand the information and I wish to proceed',
          class: 'option-consent',
          key: 'proceed'
        }
      ]
    }
  },
  {
    field: 'zalud_throatPain_complete',
    isLast: true,
    label: `Thank you for completing this questionnaire, please select "Finish" to submit`,
    type: 'info',
    answer: {}
  },
  {
    class: 'ineligible',
    field: 'zalud_throatPain_ineligible',
    label: "We're sorry you don't qualify",
    subLabel: "We're not able to continue based on your responses.",
    blockQuestionFlow: true,
    answer: {},
    type: 'info',
    isLast: true
  }
] as const;

export type ZaludThroatPainQuestionFieldAnswers = Partial<
  QuestionAnswerMap<typeof questionsModel>
>;
export default questionsModel;
